import { render, staticRenderFns } from "./CourtSettings.vue?vue&type=template&id=725b45d0&scoped=true&"
import script from "./CourtSettings.vue?vue&type=script&lang=js&"
export * from "./CourtSettings.vue?vue&type=script&lang=js&"
import style0 from "./CourtSettings.vue?vue&type=style&index=0&id=725b45d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b45d0",
  null
  
)

export default component.exports